<ng-container *ngIf="isCreateMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header [mode]="mode" [createLabel]="title"></base-form-header>

    <mat-dialog-content fxLayout="column">
      <!-- Filtre par catégories (optionnel) -->
      <base-form-input
        [items$]="categories$"
        (autocompleteChange)="loadCategories($event)"
        (onSelectItems)="onCategorySelect($event)"
        appearance="outline"
        [label]="
          isGenericPrestation
            ? 'Filtrer par catégories de prestations (optionnel)'
            : 'Filtrer par catégories d\'articles (optionnel)'
        "
        displayProperty="label"
        controlName="categories"
        type="search-multiple"
        [withoutPadding]="true"
        hint="Sélectionnez des catégories pour filtrer la liste ci-dessous"
      ></base-form-input>

      <!-- Sélection des éléments génériques (obligatoire) -->
      <base-form-input
        [items$]="items$"
        (autocompleteChange)="autocompleteGenericItems($event)"
        (onScroll)="onScrollLine($event, isGenericPrestation ? 'genericPrestation' : 'genericProduct')"
        appearance="outline"
        [label]="isGenericPrestation ? 'Prestations génériques' : 'Articles génériques'"
        displayProperty="label"
        controlName="genericItems"
        type="search-multiple"
        [withoutPadding]="true"
      ></base-form-input>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <base-form-input
        type="submit"
        [mode]="mode"
        [loading]="loading"
        entityLabel="USER"
        (onCreate)="createItem()"
        [disabled]="form.invalid"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>
